import moment from "moment";
import React, { useEffect, useState } from "react";
import { BackButton, TableData } from "../../components";
import { errorAlert } from "../../helpers/alerts";
import { useNavigate } from "react-router-dom";
import { getDayIntermittences } from "services/admin/alertsService";

const PanelIntermitenciasScreen = ({ slim }) => {
  const navigate = useNavigate();
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const shortList = new Array(15).fill({});

  useEffect(() => {
    setLoading(true)
    getDayIntermittences().then((response) => {
      setList(response);
    }).catch(error => errorAlert(error))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      {!slim && <BackButton name={'Regresar'} click={() => navigate(-1)} />}
      <TableData
        title={"Intermitencias (24hrs)"}
        onTitleClick={() => slim && navigate('../admin/alertas/intermitencias')}
        rowsPerPageOpt={50}
        autonumber={false}
        pagination={false}
        loading={loading}
        headerStyle={slim && {
          fontSize: 10,
        }}
        dataRows={(slim ? shortList.map((item, i) => list[i] || {}) : list).map((item) => ({
          ...item,
          style: {
            fontSize: 11,
          }
        }))}
        dataTitle={[
          "Id",
          "Hora",
          "Instancia",
          "Txns",
          "Duracion",
        ]}
        formatter={({
          identification,
          providerCredential,
          txns,
          createdAt,
          end
        }) => ([
          identification || '-',
          createdAt ? moment(createdAt).format('HH:mm:ss') : '-',
          providerCredential?.name_connector ? {
            type: 'text',
            value: providerCredential?.name_connector,
            maxWidth: 100
          } : '-',
          txns?.length || '-',
          end ? moment(end).diff(moment(createdAt), 'minutes') + ' min' : '-',
        ])}
      />
    </>
  );
};

export default PanelIntermitenciasScreen;
